import BasePage from "@Scripts/Pages/BasePage";
import KnockOut from "knockout";
import CheckoutSummaryViewModel from "@Scripts/ViewModels/CheckOutSummaryViewModel";

export default class CheckoutSummaryPage extends BasePage {
    public static async init() {
        await super.init();

        (<any>window).App.viewModels.page = new CheckoutSummaryViewModel();
        KnockOut.applyBindings((<any>window).App.viewModels.page, document.getElementById("Page"));

        this.setUpSelling();
    }

    public static setUpSelling() {
        var upSelling = document.getElementById("UpSellingProducts");
        var close = document.querySelector(".dialog .close");

        if (upSelling) {
            setTimeout(function () {
                upSelling.classList.remove("hidden");
            }, 2000);

            close.addEventListener("click", x => {
                upSelling.classList.add("hidden");
            });

            upSelling.onclick = function (e) {
                if (e.target == document.getElementById('UpSellingProducts')) {
                    upSelling.classList.add("hidden");
                }
            }
        }
    }
}